import { GraphQLFormattedError } from 'graphql';

export const getApiErrorMessage = (graphqlError: GraphQLFormattedError) => {
  switch (graphqlError.message) {
    case 'USER_IS_VALIDATED':
      return 'Vous ne pouvez pas modifier un utilisateur déjà validé';
    case 'NO_CURRENT_MILESTONE':
      return "Il n'y a pas de palier actuellement";
    case 'USER_ALREADY_JOINED':
      return 'Vous êtes déjà dans cet événement';
    case 'EVENT_IS_PAST':
      return "L'événement est déjà passé";
    case 'MILESTONE_NOT_FOUND':
      return "Le palier n'a pas été trouvé";
    case 'USER_ALREADY_PAID':
      return 'Il y a déjà un paiement à ce sujet pour cet événement';
    case 'USER_ALREADY_PAYING':
      return "Vous avez déjà une transaction en cours, si ce problème persiste, contactez l'orga";
    case 'USER_HAS_NO_CAUTION':
      return 'Vous ne pouvez pas valider un utilisateur sans caution';
    case 'USER_HAS_NOT_PAID':
      return 'Vous ne pouvez pas valider un utilisateur sans paiement';
    case 'EVENT_HARD_PLACES_FULL':
      return "Il n'y a plus de place en chambre pour cet événement :(";
    case 'EVENT_FULL':
      return "Il n'y a plus de place pour cet événement :(";
    case 'IMPETRANT_CANNOT_BE_REFERENT':
      return 'Un impétrant ne peut pas être référent';
    case 'SYMPATHISANT_CANNOT_BE_REFERENT':
      return 'Un sympathisant ne peut pas être référent';
    case 'MISSING_REFERENT':
      return 'Vous devez renseigner un référent complet si vous êtes un impétrant ou un sympathisant';
    case 'PLACE_HAS_LINKED_EVENT':
      return 'Vous ne pouvez pas supprimer un lieu lié à un événement';
    case 'BEDROOM_ALREADY_EXISTS':
      return 'Une chambre avec ce numéro et étage existe déjà';
    case 'NO_PAID_TRANSACTION_FOR_BEDROOM':
      return "Il n'y a pas de paiement en chambre pour cet événement";
    case 'ALREADY_HAS_BEDROOM':
      return 'Vous avez déjà une chambre pour cet événement';
    case 'VOUCHER_HAS_TRANSACTIONS':
      return 'Vous ne pouvez pas supprimer un code de réduction ayant des transactions';
    case 'VOUCHER_NOT_FOUND':
      return "Le code de réduction n'a pas été trouvé";
    case 'MISSING_USER_INFOS':
      return 'Vous devez renseigner vos informations personnelles avant de pouvoir payer';
    case 'USER_HAS_NOT_JOINED':
      return "Vous ne pouvez pas quitter un événement que vous n'avez pas rejoint";
    case 'NEED_REFUND':
      return "Vous devez être remboursé avant de pouvoir quitter l'événement, contactez l'orga";
    case 'VOUCHER_REQUIRED':
      return 'Les paiements sont réservés aux détenteurs d’un code de réduction pour le moment';
    case 'USER_NOT_FOUND':
      return "Aucun utilisateur n'a été trouvé avec ce code";
    case 'USER_HAS_NO_TICKET':
      return 'Vous devez avoir une place pour cet événement avant de faire ça';
    case 'PAYMENTS_DISABLED':
      return 'Les paiements sont désactivés pour le moment';
    case 'USER_NOT_JOINED_EVENT':
      return "Vous devez avoir rejoint l'événement pour effectuer cette action";
    case 'USER_HAS_NOT_PAID_TICKET':
      return 'Vous devez avoir payé votre place pour faire ça';
    case 'INVALID_CARPOOL_SEATS':
      return 'Le nombre de places du covoiturage doit être supérieur à 0';
    case 'USER_ALREADY_DRIVING_CARPOOL_TRIP':
      return 'Vous proposez déjà un trajet pour cet événement';
    case 'DRIVER_CANNOT_BE_PASSENGER':
      return 'Vous ne pouvez pas proposer un trajet si vous êtes déjà passager';
    case 'CANNOT_JOIN_OWN_CARPOOL_TRIP':
      return 'Vous ne pouvez pas rejoindre votre propre trajet';
    case 'PASSENGER_CANNOT_BE_DRIVER':
      return 'Vous ne pouvez pas rejoindre un trajet si vous en proposez déjà un';
    case 'USER_ALREADY_JOINED_CARPOOL_TRIP':
      return 'Vous avez déjà rejoint ce trajet';
    case 'USER_ALREADY_JOINED_ANOTHER_CARPOOL_TRIP':
      return 'Vous avez déjà rejoint un autre trajet pour cet événement';
    case 'CARPOOL_TRIP_FULL':
      return 'Ce trajet est complet';
    case 'NOT_CARPOOL_TRIP_DRIVER':
      return 'Seul le conducteur peut supprimer ce trajet';
    case 'FORBIDDEN_FILE_TYPE':
      return "Le type de fichier n'est pas autorisé";
    case 'BEDROOM_FULL':
      return 'La chambre est pleine';
    case 'NO_MORE_BEDROOM':
      return "Il n'y a plus de places en chambre disponible pour cet événement";
    case 'SUPER_LIKE_LIMIT_REACHED':
      return 'Vous avez atteint la limite de super like';
    default:
      return `Une erreur est survenue : ${graphqlError.message}`;
  }
};
